import React, { useRef } from "react";
import { ListTodo, ClipboardList } from "lucide-react";
import MyTaskList from "./MyTaskList/MyTaskList";
import MyIndividualTaskList from "../MyIndividualTaskListManagement/MyIndividualTaskList/MyIndividualTaskList";
import Accordion from "react-bootstrap/Accordion";
import "./MyTaskListManagement.css";
import { useTranslation } from "react-i18next";

const MyTaskListManagement = () => {
  const { t } = useTranslation();
  const myIndividualTaskListRef = useRef(null);
  const mySopRef = useRef(null);

  const handleRefreshDailyTasks = () => {
    // Call the refresh function from MyIndividualTaskList component
    if (
      myIndividualTaskListRef.current &&
      myIndividualTaskListRef.current.refreshTaskList
    ) {
      myIndividualTaskListRef.current.refreshTaskList();
    }
  };

  const handleRefreshsopTask = () => {
    // Call the refresh function from MyTaskList component
    if (
      mySopRef.current &&
      mySopRef.current.refreshSopList
    ) {
      mySopRef.current.refreshSopList();
    }
  };

  return (
    <div className="mytask-wrapper">
      <div className="mytask-page-header">
        <div className="mytask-page-header-icon">
          <ListTodo size={14} color="#fff" />
        </div>
        <div className="mytask-page-header-title">{t("task_management_header")}</div>
      </div>
      <Accordion defaultActiveKey="0" flush className="mytask-accordion">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                // justifyContent: "space-between",
                width: "100%",
              }}
            >
              <ListTodo size={14} />
              <span>{t("daily_operational_task_header")}</span>
              {/* <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleRefreshDailyTasks();
                }}
                style={{
                  background: "#18A3A0",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                  marginLeft: "10px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                }}
                title={
                  t("refresh_daily_tasks_tooltip") || "Refresh Daily Tasks"
                }
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button> */}
            </div>
          </Accordion.Header>
          <Accordion.Body className="accordion-body-style">
            <div>
              <MyIndividualTaskList ref={myIndividualTaskListRef} />
            </div>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                // justifyContent: "space-between",
                width: "100%",
              }}
            >
              <ClipboardList size={14} />
              <span>{t("sop_related_task_header")}</span>
              {/* <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleRefreshsopTask();
                }}
                style={{
                  background: "#18A3A0",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                  marginLeft: "10px",
                  padding: "4px 8px",
                  borderRadius: "4px",
                }}
                title={
                  t("refresh_sop_tasks_tooltip") || "Refresh SOP Tasks"
                }
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button> */}
            </div>
          </Accordion.Header>
          <Accordion.Body className="accordion-body-style">
            <MyTaskList ref={mySopRef} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default MyTaskListManagement;